"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isReportDateLessThanMaxFutureBusinessDays = exports.isSupportedFileExtension = void 0;
const finley_types_1 = require("@finley-technologies/finley-types");
const consts_1 = __importDefault(require("../consts"));
const date_1 = __importDefault(require("../date"));
const isSupportedFileExtension = (ext) => {
    return finley_types_1.Util.SupportedFileExtensionIterable.includes(ext);
};
exports.isSupportedFileExtension = isSupportedFileExtension;
const isReportDateLessThanMaxFutureBusinessDays = (reportingDate) => {
    const currentDateStr = date_1.default.currentDateStr();
    const earlyUploadThreshold = date_1.default.addBusinessDays(currentDateStr, consts_1.default.maxFutureBusinessDaysReportingDate);
    if (date_1.default.fullDateStrToEpoch(reportingDate) >
        date_1.default.fullDateStrToEpoch(earlyUploadThreshold)) {
        return false;
    }
    return true;
};
exports.isReportDateLessThanMaxFutureBusinessDays = isReportDateLessThanMaxFutureBusinessDays;
//# sourceMappingURL=validate.js.map